// src/routes/app.tsx
import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'

const AppDashboard = lazy(() => import('../pages/AppDashboard'))
const Videocursus = lazy(() => import('../pages/Videocursus'))
const Theorieboek = lazy(() => import('../pages/Theorieboek'))
const Notities = lazy(() => import('../pages/Notities'))
const Oefenexamens = lazy(() => import('../pages/Oefenexamens'))
const Verkeersborden = lazy(() => import('../pages/Verkeersborden'))
const Downloads = lazy(() => import('../pages/Downloads'))
const Account = lazy(() => import('../pages/Account'))
const Bestellingen = lazy(() => import('../pages/Bestellingen'))
const Voortgang = lazy(() => import('../pages/Voortgang'))
const Leercoach = lazy(() => import('../pages/Leercoach'))
const LeercoachOefenen = lazy(() => import('../pages/LeercoachOefenen'))
const Instellingen = lazy(() => import('../pages/Instellingen'))

export const APP_SECTION_ROUTES = (
  <>
    <Route index element={<Navigate to="oefenexamens" replace />} />
    <Route path="dashboard" element={<AppDashboard />} />
    <Route path="leercoach" element={<Leercoach />} />
    <Route path="leercoach/oefenen" element={<LeercoachOefenen />} />
    <Route path="videocursus" element={<Videocursus />} />
    <Route path="theorieboek" element={<Theorieboek />} />
    <Route path="notities" element={<Notities />} />
    <Route path="oefenexamens" element={<Oefenexamens />} />
    <Route path="verkeersborden" element={<Verkeersborden />} />
    <Route path="downloads" element={<Downloads />} />
    <Route path="voortgang" element={<Voortgang />} />
    <Route path="account" element={<Account />} />
    <Route path="instellingen" element={<Instellingen />} />
    <Route path="bestellingen" element={<Bestellingen />} />
    {/* Old routes now live under the combined Voortgang page */}
    <Route path="charts" element={<Navigate to="/app/voortgang" replace />} />
    <Route path="productiviteit" element={<Navigate to="/app/voortgang?tab=productiviteit" replace />} />
    <Route path="*" element={<Navigate to="oefenexamens" replace />} />
  </>
)
